"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newHotspotPinComponent = void 0;
const geometry_1 = require("../geometry");
const order_1 = require("../order");
const random_id_1 = require("../random-id");
const tip_tap_1 = require("../../tip-tap");
const pin_component_1 = require("./pin-component");
function newHotspotPinComponent({ position = pin_component_1.initialPinComponentPosition, settings = {}, diameter = 75, order = order_1.defaultOrder, rotation, id, }) {
    return {
        type: 'HOTSPOT',
        id: id || (0, random_id_1.randomId)(),
        settings: {
            fillType: settings.fillType || 'ICON',
            iconFill: settings.iconFill || 'ADD',
            imageFill: settings.imageFill || {
                name: 'demo-image.jpg',
                url: 'https://lh3.googleusercontent.com/QjsbtROFsiGYbXAtGymx8rQaasKbIQ9f1YwUEkJL8fWlmwafNHImcWL5ot-IYZuEaZfG85HQS5bJWufho0kpQmeGG2yodzOiKZ9GTKE=s800',
            },
            textFill: settings.textFill || 'ABC',
            showBody: false,
            expandDirection: 'AUTO',
            body: settings.body ? (0, tip_tap_1.stringToLeanProsemirror)(settings.body) : (0, tip_tap_1.emptyDocument)(),
            linkedPinComponent: settings.linkedPinComponent,
            movableInInteractiveViewer: settings.movableInInteractiveViewer,
            title: settings.title ? (0, tip_tap_1.stringToLeanProsemirror)(settings.title) : (0, tip_tap_1.emptyDocument)(),
        },
        layout: (0, geometry_1.newBox)(position, (0, geometry_1.newSize)(diameter, diameter), rotation, true),
        order,
    };
}
exports.newHotspotPinComponent = newHotspotPinComponent;
//# sourceMappingURL=hotspot-pin-component.js.map